export default __webpack_public_path__ + "static/media/tree-dark.42e86023.svg";